'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var LoginContact = (_dec = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(LoginContact, _Component);

  function LoginContact() {
    (0, _classCallCheck3.default)(this, LoginContact);
    return (0, _possibleConstructorReturn3.default)(this, (LoginContact.__proto__ || (0, _getPrototypeOf2.default)(LoginContact)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginContact, [{
    key: 'onSend',
    value: function onSend() {
      this.modal.close();
      _toastr2.default.success(this.props.t('Enquiry sent'));
    }
  }, {
    key: 'open',
    value: function open() {
      this.modal.open();
    }
  }, {
    key: 'close',
    value: function close() {
      this.modal.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modalBackdrop = 'static';
      var isCloseByEscEnabled = false;
      var t = this.props.t;


      return _react2.default.createElement(
        _components.Modal,
        {
          ref: function ref(el) {
            return _this2.modal = el;
          },
          title: t('Contact us to find out more'),
          backdrop: modalBackdrop,
          closeByEsc: isCloseByEscEnabled
        },
        _react2.default.createElement(_components.LoginContactForm, { onSend: this.onSend })
      );
    }
  }]);
  return LoginContact;
}(_react.Component), _class3.propTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSend', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSend'), _class2.prototype)), _class2)) || _class);
exports.default = LoginContact;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginContact/LoginContact.js
// module id = 2161
// module chunks = 1